import { useForm } from "@refinedev/react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "@/components/forms/PageHeader";

const MARCAS = ["Electrimotos", "Revoo", "VIP Celulares", "Mixto"];
const TIPOS = [
  { value: "moto", label: "Motos" },
  { value: "celular", label: "Celulares" },
  { value: "mixto", label: "Mixto" },
];

export function TiendaForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const {
    refineCore: { onFinish, formLoading },
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    refineCoreProps: {
      resource: "tiendas",
      action: isEdit ? "edit" : "create",
      id,
      redirect: false,
      onMutationSuccess: () => navigate("/admin/tiendas"),
    },
  });

  return (
    <div className="max-w-2xl">
      <PageHeader title={isEdit ? "Editar tienda" : "Nueva tienda"} />
      <form onSubmit={handleSubmit(onFinish)} className="card p-6 space-y-4">
        <Field label="Código" error={errors.codigo?.message}>
          <input
            {...register("codigo", { required: "Requerido" })}
            className="input"
            placeholder="EM-PEI"
          />
        </Field>
        <Field label="Nombre" error={errors.nombre?.message}>
          <input {...register("nombre", { required: "Requerido" })} className="input" />
        </Field>
        <Field label="Marca" error={errors.marca?.message}>
          <select {...register("marca", { required: "Requerido" })} className="input">
            <option value="">Selecciona...</option>
            {MARCAS.map((m) => <option key={m} value={m}>{m}</option>)}
          </select>
        </Field>
        <Field label="Tipo de producto" error={errors.tipo_producto?.message}>
          <select {...register("tipo_producto", { required: "Requerido" })} className="input">
            {TIPOS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </Field>
        <Field label="Ciudad" error={errors.ciudad?.message}>
          <input {...register("ciudad", { required: "Requerido" })} className="input" />
        </Field>
        <h3 className="font-medium pt-2 border-t border-border">Cuenta bancaria (autocompleta al registrar pagos)</h3>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Banco">
            <input {...register("banco_default")} className="input" placeholder="Bancolombia" />
          </Field>
          <Field label="Tipo de cuenta">
            <select {...register("tipo_cuenta_default")} className="input">
              <option value="">Sin definir</option>
              <option value="ahorros">Ahorros</option>
              <option value="corriente">Corriente</option>
            </select>
          </Field>
        </div>
        <Field label="N° cuenta">
          <input {...register("cuenta_banco_default")} className="input" />
        </Field>
        <Field label="Titular de la cuenta">
          <input {...register("titular_cuenta_default")} className="input" />
        </Field>
        <Field label="Email notificaciones">
          <input
            type="email"
            {...register("email_notificaciones")}
            className="input"
          />
        </Field>

        <footer className="flex gap-2 pt-2">
          <button type="submit" disabled={formLoading} className="btn-primary">
            {formLoading ? "Guardando..." : "Guardar"}
          </button>
          <button type="button" onClick={() => navigate(-1)} className="btn-secondary">
            Cancelar
          </button>
        </footer>
      </form>
    </div>
  );
}

function Field({
  label,
  error,
  children,
}: {
  label: string;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-1">
      <label className="text-sm font-medium">{label}</label>
      {children}
      {error && <p className="text-xs text-error">{error}</p>}
    </div>
  );
}
